import { render, staticRenderFns } from "./client-profile-details-loader.vue?vue&type=template&id=56599be6"
import script from "./client-profile-details-loader.vue?vue&type=script&lang=js"
export * from "./client-profile-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports